import { AddressFormState } from 'ia-react-core/~/interfaces/AddressFormState';
import { ParametersExceptFirst } from 'ia-react-core/~/interfaces/ParametersExceptFirst';

import withName from '../../../hocs/helpers/_withName';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import injectReducer from '../../../hocs/redux/injectReducer';
import injectTranslations from '../../../hocs/translation/injectTranslations';
import compose from '../../../utils/components/_compose';

import startManualAddressEntryById from '../../../actions/addressForm-fn/startManualAddressEntryById';
import stopManualAddressEntryById from '../../../actions/addressForm-fn/stopManualAddressEntryById';

import en from './translations/en';
import fr from './translations/fr';

import AddressForm, { AddressFormComposedProps } from './AddressForm';

import addressformReducer from './AddressForm.reducer';

export * from './AddressForm';

export default compose<typeof AddressForm>(
  withUniqueId('formId'),
  withName('Form', 'formId'),
  // No schema as is not allowed as first level form
  injectTranslations('Core.AddressForm', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
  injectReducer<AddressFormComposedProps, AddressFormState>({
    key: ({ name }) => `${name}AddressForm`,
    idName: 'formId',
    namespace: 'Core/AddressForm',
    identifiers: ({ formId, name }) => ({ formId, name }),
    reducer: addressformReducer,
    actions: ({ formId }) => ({
      startManualEntry: (...args: ParametersExceptFirst<typeof startManualAddressEntryById>) => startManualAddressEntryById(formId, ...args),
      stopManualEntry: (...args: ParametersExceptFirst<typeof stopManualAddressEntryById>) => stopManualAddressEntryById(formId, ...args),
    }),
    initialState: (props) => {
      const { formId, name, initialManualEntry } = props;

      return ({
        formId,
        name,
        isManualEntry: initialManualEntry ?? false,
      });
    },
    useScope: true,
    createScope: false,
    cleanState: true,
  }),
)(AddressForm);
